export default __webpack_public_path__ + "static/media/sustainability13.5443f821.jpeg";